import { Component, DestroyRef, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IAmanoOne_ParkerSyncComparisonForLotResponse,
  IParcsGetLotConfigurationResponse,
} from 'src/app/shared/code/interfaces/parcs-interfaces';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { JsonpClientBackend } from '@angular/common/http';
import { JsonPipe } from '@angular/common';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { ProcessingBannerComponent } from 'src/app/shared/ui/processing-banner/processing-banner.component';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { IgxGridComponent, IgxTabsModule } from '@infragistics/igniteui-angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { DialogSyncAmanoOneComponent } from 'src/app/core/dialog/dialog-sync-amano-one/dialog-sync-amano-one.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DialogConfirmAmanoOneSyncComponent } from 'src/app/core/dialog/dialog-confirm-amano-one-sync/dialog-confirm-amano-one-sync.component';
import { MatInputModule } from '@angular/material/input';
import { firstValueFrom } from 'rxjs';
import { MatCardModule } from '@angular/material/card';
import { ClipboardModule } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-amano-one-sync',
  standalone: true,
  imports: [
    CommonModule,
    ProcessingBannerComponent,
    IgxGridModule,
    IgxTabsModule,
    IgxGridComponent,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatInputModule,
    MatCardModule,
    ClipboardModule,
  ],
  templateUrl: './amano-one-sync.component.html',
  styleUrl: './amano-one-sync.component.scss',
})
export class AmanoOneSyncComponent implements OnInit {
  @ViewChild('gridParkerSync', { read: IgxGridComponent, static: true })
  syncData: IAmanoOne_ParkerSyncComparisonForLotResponse[] = [];
  displaySyncData: IAmanoOne_ParkerSyncComparisonForLotResponse[] = [];
  loadingMessage: string = undefined;
  selectedSyncStatusToggle: string = 'all';
  matchedRecordsCount: number;
  unmatchedRecordsCount: number;
  isNewAccessHolder: boolean = false;
  lotParcsConfiguration: IParcsGetLotConfigurationResponse = {} as IParcsGetLotConfigurationResponse;
  isParcsEnabledForCurrentLotNumber: boolean = undefined;
  numberOfParkersFound: number = 0;
  numberOfParcsFound: number = 0;
  parkerNameMatches: number = 0;
  companyNameMatches: number = 0;
  syncStatusDescription: string = 'This lists all Active Parkers and Amano One Access Holders.';

  _parcsDataService = inject(ParcsDataService);
  _destroyRefService = inject(DestroyRef);
  _appGeneralStateService = inject(AppGeneralStateService);
  _dialogService = inject(MessageDialogService);
  _matDialogService = inject(MatDialog);

  clipboard: any;
  public options = {
    enabled: true,
    copyHeaders: true,
    copyFormatters: true,
    separator: '\t',
  };

  constructor() {}

  ngOnInit(): void {
    this.getParcsLotConfigurationData(this._appGeneralStateService.currentLotNumber);

    this._appGeneralStateService.lotNumberSubject.subscribe({
      next: (v) => this.onLotNumberChange(v),
    });
  }

  onLotNumberChange(newLotNumber: string): void {
    this.syncData = [];
    this.displaySyncData = [];
    this.getParcsLotConfigurationData(newLotNumber);
    this.getSyncDataForLot(newLotNumber);
  }

  onViewChange(view: string): void {
    this.selectedSyncStatusToggle = view;
    this.displaySyncData = [];
    this._dialogService.snackBarTopCenterTimed('Updating View...', 1500);
    if (this.selectedSyncStatusToggle === 'all') {
      this.displaySyncData = this.syncData;
      this.syncStatusDescription = 'This lists all Active Parkers and Amano One Access Holders.';
    } else if (this.selectedSyncStatusToggle === 'match') {
      this.syncStatusDescription =
        'This lists all Parkers and Amano One Access Holders where the card Number, Parker Name and Company match.';
      this.displaySyncData = this.syncData.filter((item) => item.status == 0);
    } else if (this.selectedSyncStatusToggle === 'ready') {
      this.syncStatusDescription = 'This lists all Parkers and Amano One Access Holders where card numbers match .';
      this.displaySyncData = this.syncData.filter((item) => item.status == 1);
    } else if (this.selectedSyncStatusToggle === 'review') {
      this.syncStatusDescription = 'This lists all Parkers with no matching Amano One Access Holders';
      this.displaySyncData = this.syncData.filter((item) => item.status == 2);
    } else if (this.selectedSyncStatusToggle === 'unable') {
      this.syncStatusDescription = 'This lists Amano One Access Holders with no Parker match.';
      this.displaySyncData = this.syncData.filter((item) => item.status == 3);
    } else if (this.selectedSyncStatusToggle === 'synced') {
      this.syncStatusDescription = 'This lists all Parkers and Amano One Access Holders where sync has been applied.';
      this.displaySyncData = this.syncData.filter((item) => item.status == 10);
    } else {
      this.displaySyncData = this.syncData;
    }
  }

  onEditThenSyncParkerToParcs(parkerParcsData: IAmanoOne_ParkerSyncComparisonForLotResponse): void {
    const previousCardNumber: string = parkerParcsData.amanoOneCardNumber;
    const parcsAccessHolderId: string = parkerParcsData.amanoOneAccessHolderId;

    this.isNewAccessHolder = this.isAccountHolderIdNullOrEmpty(parkerParcsData.amanoOneAccessHolderId);

    const dialogRef = this._matDialogService.open(DialogSyncAmanoOneComponent, {
      hasBackdrop: true,
      maxWidth: '80vw',
      width: '80vw',
      maxHeight: '75vh',
      height: '75vh',
      panelClass: 'custom-dialog-container',
      data: {
        syncData: parkerParcsData,
        isNewAccessHolder: this.isNewAccessHolder,
      },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        if (result.formData.parkerCardNumber !== previousCardNumber) {
        }
        const accessGroupId: string = result.accessGroupId || '';
        const accessHolderId: string = result.accessHolderId || '';
        await this.doSyncOnSpecificParker(parkerParcsData, parcsAccessHolderId, previousCardNumber);
      }
    });
  }

  onSyncNowParkerToParcs(): void {
    const dialogRef = this._matDialogService.open(DialogConfirmAmanoOneSyncComponent, {
      hasBackdrop: true,
      maxWidth: '50vw',
      width: '50vw',
      maxHeight: '60vh',
      height: '60vh',
      panelClass: 'custom-dialog-container',
      data: {
        syncData: this.displaySyncData.length,
      },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.doSyncOnAllDisplayData();
      }
    });
  }

  private isAccountHolderIdNullOrEmpty(value: string | null | undefined): boolean {
    return value == null || value === '' || value === undefined || value === '00000000-0000-0000-0000-000000000000';
  }

  calculateParcsSyncMetrics(): void {
    this.unmatchedRecordsCount = 0;
    this.matchedRecordsCount = 0;
    var ii: 0;

    this.numberOfParkersFound = this.syncData[0].numberOfParkersFound;
    this.numberOfParcsFound = this.syncData[0].numberOfParcsFound;

    const parkersSyncOnly: IAmanoOne_ParkerSyncComparisonForLotResponse[] = this.syncData.filter(
      (item) => item.parkerProfileExists == true,
    );

    for (ii = 0; ii < this.syncData.length; ii++) {
      //assume unmatched and change if match found
      this.syncData[ii].matchedParkerPARCS = false;
      if (
        this.isAccountHolderIdNullOrEmpty(this.syncData[ii].parkerCardNumber) ||
        this.isAccountHolderIdNullOrEmpty(this.syncData[ii].amanoOneCardNumber)
      ) {
        continue;
      }
      if (
        this.isAccountHolderIdNullOrEmpty(this.syncData[ii].parkerCardNumber) ===
        this.isAccountHolderIdNullOrEmpty(this.syncData[ii].amanoOneCardNumber)
      ) {
        this.syncData[ii].matchedParkerPARCS = true;
        this.matchedRecordsCount++;
      }
    }

    this.calculateParkerNameDiscrepancy(parkersSyncOnly);
    this.calculateCompanyNameDiscrepancy(parkersSyncOnly);

    this.unmatchedRecordsCount = this.syncData.length - this.matchedRecordsCount;
  }

  calculateParkerNameDiscrepancy(parkersSyncOnly: IAmanoOne_ParkerSyncComparisonForLotResponse[]): void {
    let ii: number = 0;
    let numberNameMatches: number = 0;

    for (ii = 0; ii < parkersSyncOnly.length; ii++) {
      const isParkerNameMatching: boolean = this.syncData.some(
        (item) => item.parkerProfileExists == true && item.parkerFullName == this.syncData[ii].amanoOneFullName,
      );
      isParkerNameMatching ? numberNameMatches++ : null;
    }

    this.parkerNameMatches = numberNameMatches;
  }

  calculateCompanyNameDiscrepancy(parkersSyncOnly: IAmanoOne_ParkerSyncComparisonForLotResponse[]): void {
    let ii: number = 0;
    let numberCompanyMatches: number = 0;

    for (ii = 0; ii < parkersSyncOnly.length; ii++) {
      const isCompanyNameMatching: boolean = this.syncData.some(
        (item) => item.parkerProfileExists == true && item.parkerCompanyName == this.syncData[ii].amanoOneCompanyName,
      );
      isCompanyNameMatching ? numberCompanyMatches++ : null;
    }

    this.companyNameMatches = numberCompanyMatches;
  }

  getSyncDataForLot(lotNumber: string): void {
    this.loadingMessage = 'Getting Parker/PARCS Sync Data...';
    this._parcsDataService
      .getParcsLotSyncDataForLotNumber(lotNumber)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.selectedSyncStatusToggle = 'all';
          this.syncData = res;
        },
        error: (err: any) => {
          this.loadingMessage = undefined;
        },
        complete: () => {
          this.loadingMessage = undefined;
          this._dialogService.snackBarTopCenterTimed('Parker/PARCS Sync Data Loaded Successfully', 3000);
          this.calculateParcsSyncMetrics();
          this.displaySyncData = this.syncData;
        },
      });
  }

  addNewAmanoOneParcs(
    parkerId: string,
    accessGroupId: string,
    parker: IAmanoOne_ParkerSyncComparisonForLotResponse,
  ): void {
    this.loadingMessage = 'Adding Parker to Amano One...';
    this._parcsDataService
      .postNewAmanoOneParcsAccesHolderForExistingParkerDuringSync(parkerId, accessGroupId)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.loadingMessage = undefined;
        },
        error: (err: any) => {
          this.loadingMessage = undefined;
        },
        complete: () => {
          this.displaySyncData[this.displaySyncData.indexOf(parker)].status = 10;
          this.syncData[this.syncData.indexOf(parker)].status = 10;
        },
      });
  }

  UpdateAmanoOneParcs(
    parkerId: string,
    parker: IAmanoOne_ParkerSyncComparisonForLotResponse,
    accessHolderId: string,
  ): void {
    const previousCardNumberPlug: string = ''; // Placeholder since we don't track previous card numbers in this context
    this.loadingMessage = 'Updating Existing Amano One Access Holder...';
    this._parcsDataService
      .updateExistingAmanoOneParcsAccessHolderDuringSync(parkerId, previousCardNumberPlug, accessHolderId)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.loadingMessage = undefined;
          // 20260920 :: Ken Moss - Endpoint returns 200 with a boolean; only mark synced when it reports true.
          if (res) {
            this.displaySyncData[this.displaySyncData.indexOf(parker)].status = 10;
            this.syncData[this.syncData.indexOf(parker)].status = 10;
          } else {
            this._dialogService.snackBarTopCenterTimed('Amano One could not be updated for this parker.', 4000);
          }
        },
        error: (err: any) => {
          this.loadingMessage = undefined;
          this._dialogService.snackBarTopCenterTimed('Amano One could not be updated for this parker.', 4000);
        },
      });
  }

  async UpdateAmanoOneParcsSynchronous(
    parkerId: string,
    parker: IAmanoOne_ParkerSyncComparisonForLotResponse,
    previousCardNumber: string,
    accessHolderId?: string,
  ): Promise<boolean> {
    try {
      return await firstValueFrom(
        this._parcsDataService.updateExistingAmanoOneParcsAccessHolderDuringSync(
          parkerId,
          previousCardNumber,
          accessHolderId,
        ),
      );
    } catch {
      // 20260920 :: Ken Moss - Swallow here so one parker cannot abort the bulk sync loop below.
      return false;
    }
  }

  async doSyncOnAllDisplayData(): Promise<void> {
    const previousCardNumberPlug: string = ''; // Placeholder since we don't track previous card numbers in bulk sync
    let failureCount: number = 0;

    for (const parker of this.displaySyncData) {
      this.loadingMessage = `Updating Parker ${parker.parkerFullName} to Amano One`;

      const status: boolean = await this.UpdateAmanoOneParcsSynchronous(
        parker.parkerAccountNumberId,
        parker,
        parker.amanoOneCardNumber,
        parker.amanoOneAccessHolderId,
      );
      if (status) {
        this.displaySyncData[this.displaySyncData.indexOf(parker)].status = 10;
        this.syncData[this.syncData.indexOf(parker)].status = 10;
      } else {
        failureCount++;
      }
    }
    this.loadingMessage = undefined;
    this._dialogService.snackBarTopCenterTimed(
      failureCount > 0 ? `Sync Process Completed - ${failureCount} parker(s) could not be updated` : 'Sync Process Completed',
      3000,
    );
  }

  async onSyncNowSyncMatchedParkers(): Promise<void> {
    let parkerCount: number = 0;
    for (const parker of this.displaySyncData) {
      this.loadingMessage = `Updating Parker ${parker.parkerFullName} to Amano One`;
      const previousCardNumberPlug: string = parker.amanoOneCardNumber; // Using the existing Amano One card number as the "previous" card number for matched parkers

      const status: boolean = await this.UpdateAmanoOneParcsSynchronous(
        parker.parkerAccountNumberId,
        parker,
        previousCardNumberPlug,
        parker.amanoOneAccessHolderId,
      );
      if (status) {
        this.displaySyncData[this.displaySyncData.indexOf(parker)].status = 10;
        this.syncData[this.syncData.indexOf(parker)].status = 10;
        parkerCount++;
      }
    }
    this.loadingMessage = undefined;
    this._dialogService.snackBarTopCenterTimed('Sync Process Completed', 3000);
  }

  async doSyncOnSpecificParker(
    parker: IAmanoOne_ParkerSyncComparisonForLotResponse,
    accessHolderId: string,
    previousCardNumber: string,
  ): Promise<void> {
    if (this.isNewAccessHolder) {
      this.addNewAmanoOneParcs(parker.parkerAccountNumberId, accessHolderId, parker);
    } else {
      this.loadingMessage = `Updating Parker to Amano One`;
      const status: boolean = await this.UpdateAmanoOneParcsSynchronous(
        parker.parkerAccountNumberId,
        parker,
        previousCardNumber,
        accessHolderId,
      );
      if (status) {
        this.displaySyncData[this.displaySyncData.indexOf(parker)].status = 10;
        this.syncData[this.syncData.indexOf(parker)].status = 10;
      }
      this.loadingMessage = undefined;
    }
  }

  onCopyMessage(message: string): void {
    this._dialogService.snackBarTopCenterTimed(message, 3000);
  }

  getParcsLotConfigurationData(lotNumber: string) {
    this._parcsDataService
      .getParcsLotConfigurationByLotNumber(lotNumber)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.lotParcsConfiguration = res;

          if (this.lotParcsConfiguration.lotNumber == lotNumber) {
            this.isParcsEnabledForCurrentLotNumber = true;
          } else this.isParcsEnabledForCurrentLotNumber = false;
        },
        error: (err: any) => {
          this.isParcsEnabledForCurrentLotNumber = false; // no configuration found,
        },
        complete: () => {},
      });
  }
}
